module.exports = __webpack_public_path__ + "img/dlw-logo-new.1dbdc475.svg";